<script>
  /**
   * The data being piped into this component in Facts and figures includes commas and dollar signs.
   * Because of this, we need to assume the 'value' is a string that is ready to present. 
   * If we find data that needs to use this component that needs us to add commas, we'll need to 
   * add more processing to accommodate both use cases.
  */

  // import JsonDebug from '../../../../utilities/JsonDebug.svelte'
  import LabelValueParagraphPrimitive from '../../primitives/LabelValueParagraphPrimitive.svelte'

  /**
   * Store will pass through to the primitive without processing
   */
  export let store = undefined

  export let dataObj = undefined

  export let label = undefined
  export let value = undefined
  export let prefix = ''
  export let suffix = ''

  export let phraseMode = false
  export let linkUrl = undefined

  export let animateNumbers = false

  let objArray = []

  /**
   * if there's a data object, we'll use its key/value pairs
   * if not, we'll assume label and value are set directly, and we're only rendering one
   * 
  */
  $: ()=>{
    if(dataObj){
      objArray = Object.entries(dataObj)
    }
  }
</script>

<div class="lvp">
  { #if store }
    {#each $store as obj, i }
      <LabelValueParagraphPrimitive label={ obj[0] } value={ obj[1] } { prefix } { suffix } { phraseMode } { linkUrl } { animateNumbers } />
    { /each }
  { :else if !objArray.length > 0 }
    <LabelValueParagraphPrimitive { label } { value } { store } { prefix } { suffix } { phraseMode } { linkUrl } { animateNumbers } />
  { :else }
    {#each objArray as obj }
      <LabelValueParagraphPrimitive label={ obj[0] } value={ obj[1] } { prefix } { suffix } { phraseMode } { linkUrl } { animateNumbers } />
    { /each }
  { /if }
</div>

<style type="scss">
  .lvp {
    color: #575757;
  }
</style>